import { render, staticRenderFns } from "./TipoSolicitud.vue?vue&type=template&id=16a562e6"
import script from "./TipoSolicitud.vue?vue&type=script&lang=js"
export * from "./TipoSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports